module.exports = __webpack_public_path__ + "img/cdq2b40-01.prt.c49669ab.jpg";